import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const ContractTypesPage = lazy(() => import("@/pages/contract-types/ContractTypesPage"));
const ContractTypeCreatePage = lazy(() => import("@/pages/contract-types/ContractTypeCreatePage"));
const ContractTypeEditPage = lazy(() => import("@/pages/contract-types/ContractTypeEditPage"));

export function ContractTypeRoutes() {
  return (
    <>
      <Route path="/contract-types" element={<ProtectedRoute><ContractTypesPage /></ProtectedRoute>} />
      <Route path="/contract-types/new" element={<ProtectedRoute><ContractTypeCreatePage /></ProtectedRoute>} />
      <Route path="/contract-types/:id" element={<ProtectedRoute><ContractTypeEditPage /></ProtectedRoute>} />
    </>
  );
}
